import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdatePersonalPropertyItemInput, useGetPersonalPropertyItemsQuery } from '../generated/graphql';
import {
  clientClosePersonalPropertyItem,
  ClosePersonalPropertyItemInput,
  clientUpdatePersonalPropertyItem,
  useGraphqlClient,
} from '../graphql';
import { personalPropertyItemKeys } from './queryKeys';
import { closedAccountsQueryKey, ttDetailsKeys } from '../TtDetails';

export const useUpdatePersonalPropertyItem = () => {
  const queryClient = useQueryClient();
  const gqlClient = useGraphqlClient();

  const updatePersonalPropertyItem = useMutation({
    mutationFn: (input: UpdatePersonalPropertyItemInput) => {
      return clientUpdatePersonalPropertyItem(gqlClient, input);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(personalPropertyItemKeys.base);
    },
  });

  return { updatePersonalPropertyItem };
};

export const useClosePersonalPropertyItem = () => {
  const queryClient = useQueryClient();
  const gqlClient = useGraphqlClient();

  const closePersonalPropertyItem = useMutation({
    mutationFn: (input: ClosePersonalPropertyItemInput) => {
      return clientClosePersonalPropertyItem(gqlClient, input);
    },
    onSuccess: async (_data, variables) => {
      queryClient.invalidateQueries(personalPropertyItemKeys.base);
      queryClient.invalidateQueries(closedAccountsQueryKey(variables.householdID, 'PersonalPropertyItem'));
      // useTotalAccountsDecay reads personal property items via the generated query, so
      // invalidate its key too or the "out-dated" total stays stale after a close.
      queryClient.invalidateQueries(useGetPersonalPropertyItemsQuery.getKey({ householdID: variables.householdID }));
      await queryClient.invalidateQueries(ttDetailsKeys.base);
    },
  });

  return { closePersonalPropertyItem };
};
